export const goToExactlyLabsWebsite = () => {
  window.location.href = 'https://www.exactlylabs.com';
}